/* tslint:disable */
/* eslint-disable */
/**
 * Shared Service API
 * Shared Service API documentation.
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, } from '../base';
/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Confirm email verification with code
         * @param {ConfirmEmailVerificationDto} confirmEmailVerificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerConfirmEmailVerification: (confirmEmailVerificationDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'confirmEmailVerificationDto' is not null or undefined
            assertParamExists('authControllerConfirmEmailVerification', 'confirmEmailVerificationDto', confirmEmailVerificationDto);
            const localVarPath = `/auth/confirm-email-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(confirmEmailVerificationDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Confirm MFA reset with verification code
         * @param {ConfirmMfaResetDto} confirmMfaResetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerConfirmMfaReset: (confirmMfaResetDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'confirmMfaResetDto' is not null or undefined
            assertParamExists('authControllerConfirmMfaReset', 'confirmMfaResetDto', confirmMfaResetDto);
            const localVarPath = `/auth/confirm-mfa-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(confirmMfaResetDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Request email verification code for new users
         * @param {RequestEmailVerificationDto} requestEmailVerificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRequestEmailVerification: (requestEmailVerificationDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestEmailVerificationDto' is not null or undefined
            assertParamExists('authControllerRequestEmailVerification', 'requestEmailVerificationDto', requestEmailVerificationDto);
            const localVarPath = `/auth/request-email-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestEmailVerificationDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Request MFA reset via email verification
         * @param {RequestMfaResetDto} requestMfaResetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRequestMfaReset: (requestMfaResetDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestMfaResetDto' is not null or undefined
            assertParamExists('authControllerRequestMfaReset', 'requestMfaResetDto', requestMfaResetDto);
            const localVarPath = `/auth/request-mfa-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestMfaResetDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Exchange a password setup link for a one-time sign-in password
         * @param {AcceptPasswordSetupDto} acceptPasswordSetupDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordSetupControllerAcceptPasswordSetup: (acceptPasswordSetupDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'acceptPasswordSetupDto' is not null or undefined
            assertParamExists('passwordSetupControllerAcceptPasswordSetup', 'acceptPasswordSetupDto', acceptPasswordSetupDto);
            const localVarPath = `/auth/accept-password-setup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(acceptPasswordSetupDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Email a fresh password setup link if the account needs one
         * @param {RequestPasswordSetupLinkDto} requestPasswordSetupLinkDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordSetupControllerRequestPasswordSetupLink: (requestPasswordSetupLinkDto, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'requestPasswordSetupLinkDto' is not null or undefined
            assertParamExists('passwordSetupControllerRequestPasswordSetupLink', 'requestPasswordSetupLinkDto', requestPasswordSetupLinkDto);
            const localVarPath = `/auth/request-password-setup-link`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestPasswordSetupLinkDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function (configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Confirm email verification with code
         * @param {ConfirmEmailVerificationDto} confirmEmailVerificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerConfirmEmailVerification(confirmEmailVerificationDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authControllerConfirmEmailVerification(confirmEmailVerificationDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Confirm MFA reset with verification code
         * @param {ConfirmMfaResetDto} confirmMfaResetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerConfirmMfaReset(confirmMfaResetDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authControllerConfirmMfaReset(confirmMfaResetDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Request email verification code for new users
         * @param {RequestEmailVerificationDto} requestEmailVerificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRequestEmailVerification(requestEmailVerificationDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authControllerRequestEmailVerification(requestEmailVerificationDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Request MFA reset via email verification
         * @param {RequestMfaResetDto} requestMfaResetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRequestMfaReset(requestMfaResetDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.authControllerRequestMfaReset(requestMfaResetDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Exchange a password setup link for a one-time sign-in password
         * @param {AcceptPasswordSetupDto} acceptPasswordSetupDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordSetupControllerAcceptPasswordSetup(acceptPasswordSetupDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.passwordSetupControllerAcceptPasswordSetup(acceptPasswordSetupDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Email a fresh password setup link if the account needs one
         * @param {RequestPasswordSetupLinkDto} requestPasswordSetupLinkDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordSetupControllerRequestPasswordSetupLink(requestPasswordSetupLinkDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.passwordSetupControllerRequestPasswordSetupLink(requestPasswordSetupLinkDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AuthApiFp(configuration);
    return {
        /**
         *
         * @summary Confirm email verification with code
         * @param {ConfirmEmailVerificationDto} confirmEmailVerificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerConfirmEmailVerification(confirmEmailVerificationDto, options) {
            return localVarFp
                .authControllerConfirmEmailVerification(confirmEmailVerificationDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Confirm MFA reset with verification code
         * @param {ConfirmMfaResetDto} confirmMfaResetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerConfirmMfaReset(confirmMfaResetDto, options) {
            return localVarFp
                .authControllerConfirmMfaReset(confirmMfaResetDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Request email verification code for new users
         * @param {RequestEmailVerificationDto} requestEmailVerificationDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRequestEmailVerification(requestEmailVerificationDto, options) {
            return localVarFp
                .authControllerRequestEmailVerification(requestEmailVerificationDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Request MFA reset via email verification
         * @param {RequestMfaResetDto} requestMfaResetDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRequestMfaReset(requestMfaResetDto, options) {
            return localVarFp
                .authControllerRequestMfaReset(requestMfaResetDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Exchange a password setup link for a one-time sign-in password
         * @param {AcceptPasswordSetupDto} acceptPasswordSetupDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordSetupControllerAcceptPasswordSetup(acceptPasswordSetupDto, options) {
            return localVarFp
                .passwordSetupControllerAcceptPasswordSetup(acceptPasswordSetupDto, options)
                .then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Email a fresh password setup link if the account needs one
         * @param {RequestPasswordSetupLinkDto} requestPasswordSetupLinkDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        passwordSetupControllerRequestPasswordSetupLink(requestPasswordSetupLinkDto, options) {
            return localVarFp
                .passwordSetupControllerRequestPasswordSetupLink(requestPasswordSetupLinkDto, options)
                .then((request) => request(axios, basePath));
        },
    };
};
/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     *
     * @summary Confirm email verification with code
     * @param {ConfirmEmailVerificationDto} confirmEmailVerificationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    authControllerConfirmEmailVerification(confirmEmailVerificationDto, options) {
        return AuthApiFp(this.configuration)
            .authControllerConfirmEmailVerification(confirmEmailVerificationDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Confirm MFA reset with verification code
     * @param {ConfirmMfaResetDto} confirmMfaResetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    authControllerConfirmMfaReset(confirmMfaResetDto, options) {
        return AuthApiFp(this.configuration)
            .authControllerConfirmMfaReset(confirmMfaResetDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Request email verification code for new users
     * @param {RequestEmailVerificationDto} requestEmailVerificationDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    authControllerRequestEmailVerification(requestEmailVerificationDto, options) {
        return AuthApiFp(this.configuration)
            .authControllerRequestEmailVerification(requestEmailVerificationDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Request MFA reset via email verification
     * @param {RequestMfaResetDto} requestMfaResetDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    authControllerRequestMfaReset(requestMfaResetDto, options) {
        return AuthApiFp(this.configuration)
            .authControllerRequestMfaReset(requestMfaResetDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Exchange a password setup link for a one-time sign-in password
     * @param {AcceptPasswordSetupDto} acceptPasswordSetupDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    passwordSetupControllerAcceptPasswordSetup(acceptPasswordSetupDto, options) {
        return AuthApiFp(this.configuration)
            .passwordSetupControllerAcceptPasswordSetup(acceptPasswordSetupDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Email a fresh password setup link if the account needs one
     * @param {RequestPasswordSetupLinkDto} requestPasswordSetupLinkDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    passwordSetupControllerRequestPasswordSetupLink(requestPasswordSetupLinkDto, options) {
        return AuthApiFp(this.configuration)
            .passwordSetupControllerRequestPasswordSetupLink(requestPasswordSetupLinkDto, options)
            .then((request) => request(this.axios, this.basePath));
    }
}
